import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { AudioGeneratorPageWrapper } from "./-AudioPage"

const audioGeneratorSearchSchema = z.object({
  model: z.string().optional(),
  prompt: z.string().optional(),
})

export const Route = createFileRoute("/create/audio" as any)({
  validateSearch: audioGeneratorSearchSchema,
  component: AudioGeneratorPageWrapper,
})
